const getters = {
  selectedApplication: state => {
    return state.application ? state.application : null;
  },

  isValidToSubmit: (state, getters, rootState, rootGetters) => id => {
    //- Check for application
    const hasApplication = Boolean(state.application && state.application.id)
    if (!hasApplication) return false

    //- Check required data
    const requiredFields=['firstName', 'lastName', 'email', 'personalNumber', 'createdByPersonalNumber', 'address1', 'zip', 'city', 'country', 'mobilephone']
    const hasRequiredFields = requiredFields.every(field => Boolean(state.application[field]))
    if (!hasRequiredFields) return false

    //- Check for correct state
    const hasGoodState = rootGetters['basic/toApproveByCompanyStatesId'].includes(state.application.stateId)
    if (!hasGoodState) return false

    //- Check required refs
    const requiredRefs=['instructorId','professionId','companyId','employmentTypeId']
    const hasRequiredRefs = requiredRefs.every(field => Boolean(state.application[field]))
    if (!hasRequiredRefs) return false

    //- Check required date
    const hasDate = Boolean(state.application.employmentDate)
    if (!hasDate) return false

    return true
  },

  editableByCompanyStates: (state, getters, rootState, rootGetters) => {
    return state.application &&
    (rootGetters['basic/toApproveByCompanyStatesId'].includes(state.application.stateId) ||
    rootGetters['basic/companyDraftStateId'] === state.application.stateId ||
    rootGetters['basic/confirmedByApprentice'] === state.application.stateId)
  },

  currentStep: state => {
    return state.currentStep ? state.currentStep : null;
  },
  haveEducation: state => state.haveEducation || false
};

export default getters;
